<cx-searchbox [quickOrder]='true' [searchValueClear]="clearSearchValue"
    (selectedProductEvent)="onProductSelected($event)" [config]='QUICKORDER_SEARCH_BOX_CONFIG'></cx-searchbox>



<section *ngIf="quickOrderDetails" class="quick-prod-details">
    <p class="non-formulary-product" *ngIf="isLocationSelected && nonFormularyProduct">The product is not in your
        formulary</p>

    <!-- Restriction messages -->
   
    <section class="mt-3" *ngIf="isLocationSelected && !nonFormularyProduct">

        <ng-container *ngIf="noYFRestriction;else showYFMsg">
            <section *ngIf="productInfo.unavailable;else available">
                <p class="err-text">This product is currently unavailable</p>
            </section>
            <ng-template #available>
                <section>
                    <p class="err-text" *ngIf="!productInfo?.orderable">
                        {{ productInfo.callNote || 'This product is currently unorderable'}} </p>
                    <p class="err-text" *ngIf="!productInfo?.available">
                        This product is temporarily out of stock</p>
                    <p class="err-text" *ngIf="productInfo?.discontinued">
                        The product has been discontinued</p>
                    <p class="err-text mt-2" *ngIf="isGovtCustomer && isGovtLocationSelected &&
                        productInfo?.orderable &&
                        productInfo?.available &&
                        !productInfo?.discontinued &&
                        !priceDetails?.conditions &&
                        (!productInfo?.flu || 
                         productInfo?.flu && productInfo?.shipNow?.toLowerCase() == 'on')">
                        Product not on contract
                    </p>
                </section>
            </ng-template>
        </ng-container>
        <ng-template #showYFMsg>
            <span class="yfMsg">Our records indicate that you are not authorized by your State Health Department to purchase Yellow
                Fever vaccine. To purchase Yellow Fever vaccine, your practice must be certified by your State Health
                Department, and Sanofi Pasteur must receive proof of this certification directly from the issuing State
                Health Department. Please call Customer Service at {{ baseSiteId == 'vsh' ? '1-800-VACCINE (1-800-822-2463)'
                : '1-800-752-9338'}} to obtain contact information for the appropriate party at your State Health Department
                who can assist you with this process.
            </span>
        </ng-template>
       
    </section>
  
    

    <!-- ------------------->

    <ng-container
        *ngIf=" !isLocationSelected || (isLocationSelected && !nonFormularyProduct && noYFRestriction && getConditionCheck(productInfo))">
        <!-- Contract group -->
        <div class="row contract-grp"
            *ngIf="(!productInfo?.flu || (productInfo?.flu && productInfo?.shipNow =='ON')) && priceDetails?.conditions">
            <p class="custom-tab-title">Contract Group</p>
            <p class="text-contractGrp" *ngIf="priceDetails?.conditions.length == 1">
                {{selectedContractGroup?.contractDesc}}</p>
            <ng-select [items]="priceDetails?.conditions" [searchable]="false" [clearable]="false"
                *ngIf="priceDetails?.conditions.length > 1" bindLabel="contractDesc" bindValue="contractId"
                placeholder="Select Contract Group" class="dropdown-contractGroup"
                (change)="selectedContractGroup = $event">
            </ng-select>
        </div>
        <!-------------------------------->

        <!-- row which houses the price, unit selector and add2cart button -->
        <section class="align-items-start justify-content-between ml-0 mr-0 unit-calc" [ngClass]="!isLocationSelected ? '' : 'row'">
            <!-- unit price -->
            <section class="price-details col-lg-3 col-md-4 col-sm-6"
                *ngIf="!productInfo?.flu || (productInfo?.flu && productInfo?.shipNow =='ON')">
                <b>{{'addToCartItems.yourPrice'| cxTranslate }}</b>
                <section class="price-total">
                    <span *ngIf="!isLocationSelected || selectedLocations.length > 1 || (!priceDetails?.price || !priceDetails?.price?.value) &&
                    !priceDetails?.conditions">
                        <span>$&nbsp;--</span>
                        <div class="federal-tax" *ngIf="isLocationSelected && selectedLocations.length > 1">
                            see cart for unit pricing
                        </div>
                    </span>
                    <span
                        *ngIf="isLocationSelected && selectedLocations.length === 1 && priceDetails?.price?.value && priceDetails?.price?.value <= 0 && !priceDetails?.conditions">
                       $--
                    </span>
                    <span
                        *ngIf="isLocationSelected && selectedLocations.length === 1 && priceDetails?.price?.value && priceDetails?.price?.value > 0 && !priceDetails?.conditions">
                        <span>{{priceDetails?.price?.value | currency}}</span> {{priceDetails?.price?.currencyIso}}
                        <div class="federal-tax">{{priceDetails.fexciseTax?.value | currency}}/package Federal Excise
                            Tax
                            will be added.</div>
                    </span> 
                    <span
                        *ngIf="isLocationSelected && selectedLocations.length === 1 && !priceDetails?.price?.value && priceDetails?.conditions">
                        {{getContractPrice(selectedContractGroup)}}
                        <div *ngIf="priceDetails?.conditions && selectedContractGroup?.contractPrice?.formattedValue"
                            class="federal-tax">
                            {{priceDetails.fexciseTax?.value | currency}}/package Federal Excise Tax will be added.
                        </div>
                    </span>
                </section>
            </section>
            <!-- --------------------- -->

            <!-- quantity computation section -->
            <section class="units col-lg-5 col-md-6 col-sm-6"
                *ngIf="(!productInfo.flu || (productInfo.flu && productInfo.shipNow =='ON')) && isLocationSelected">
                <b class="prodUnits">{{'addToCartItems.units' | cxTranslate}}</b>

                <section class="unit-area">
                    <img src="../../assets/icons/{{baseSiteId}}/less_new.svg" id="{{'unitMinusQuick'+productInfo.code}}"
                        alt="minus_icon"
                        (click)="performQuantityComputationQuick(2,productInfo.code);
                    showLimitPopoverValueFor !== productInfo?.code && p.close()">

                    <input type="number" #number class="prod-quantity text-center" [value]="1" (keyup)="performQuantityComputationQuick(null,productInfo.code);
                    showLimitPopoverValueFor == productInfo?.code ? p.open() : p.close()" [ngbPopover]="popContent"
                        placement="top" triggers="manual" #p="ngbPopover" [autoClose]="false"
                        popoverClass="custom-restriction-popover" id="{{'prodQuantityQuick'+productInfo.code}}"
                        appNoMouseScroll min="0"/>

                    <img src="../../assets/icons/{{baseSiteId}}/more.svg" (click)="performQuantityComputationQuick(1,productInfo.code);
                    showLimitPopoverValueFor == productInfo?.code && p.open()"
                        id="{{'unitPlusQuick'+productInfo.code}}" alt="plus_icon">

                    <ng-template #popContent>
                        <img src="../../../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="warning_icon">
                        <span>Quantity limit is '{{productInfo.allocationInfos?.availableQty}}' Units</span>
                    </ng-template>
                </section>
                <section class="dosessection" id="{{'noOfDosesQuick'+productInfo.code}}">
                    {{productInfo.quantityPerUnit}} {{productInfo?.uom}}</section>
            </section>


            <!--Reserve Now-->
            <div class="col-lg-8 col-md-6 col-sm-6" *ngIf="buttonName === 'Reserve'">
                <p *ngIf="baseSiteId == 'vsh'">
                    For assistance with your reservation,<span class="callDetails"> call 1-800-VACCINE
                        (1-800-822-2463)</span> or contact your Sanofi Pasteur vaccine
                    specialist.
                </p>
                <p *ngIf="baseSiteId == 'vax'">
                    For assistance with your reservation,<span class="callDetails"> call 1-800-752-9338</span> or
                    contact your Sanofi Pasteur vaccine
                    specialist.
                </p>
            </div>
            <!-- ------------------------  -->

            <!-- add 2 cart button -->
            <div class="btContentBlock pt-3" [ngClass]="!isLocationSelected ? 'col-auto' : 'col-lg-4 col-md-6 col-sm-12'">
                <!--RMGP - Govt user check-->
                <div *ngIf="isGovtCustomer && isGovtLocationSelected &&
            productInfo?.orderable &&
            productInfo?.available &&
            !productInfo?.discontinued &&
            !priceDetails?.conditions &&
            (!productInfo?.flu || 
             productInfo?.flu && productInfo?.shipNow?.toLowerCase() == 'on')
             ;else normalUserFlow">
                    <!--Message moved up
                    <div>Product not on contract</div>-->
                </div>
                <!--add to cart button in case of normal user-->
                <ng-template #normalUserFlow>
                    <button type="button" class="btn-primary" [ngbPopover]=popTitleSuccess placement="bottom"
                        triggers="manual" #p2="ngbPopover" popoverClass="savesuccess-msg" [closeDelay]="500"
                        [ngClass]="cssClassForButton()" (click)="addToCart(productInfo?.code+'q',productInfo?.code)">

                        <ng-template #popTitleSuccess>
                            <div class="cart-value-added">
                                <img src="../../../assets/icons/confirmation-positive-green.png"
                                    class="positive-green-icon" alt="suc">
                                <span class="confirmation-itemsadded">{{itemAddedQuantity}}
                                    {{'addToCartItems.addEntrySuccess'|cxTranslate}}</span>
                            </div>
                        </ng-template>
                        <i *ngIf="buttonName === 'Reserve'" class="fa fa-calendar" aria-hidden="true"></i>
                        {{buttonName}}
                    </button>
                </ng-template>
            </div>
            <!-- -------------------------- -->
        </section>
        <!-- --------------------------------->
    </ng-container>

    <div class="allocation-info" *ngIf="isLocationSelected 
                && !nonFormularyProduct
                && noYFRestriction
                && !productInfo.unavailable
                && productInfo?.orderable 
                && productInfo?.available 
                && !productInfo?.discontinued
                && productInfo?.allocationInfos">
        <p>This product has quantity limits</p>
        <p (click)="openLimitationModal()">View Details</p>
    </div>

    <!-- Location Point  -->
    <section class="loc" *ngIf="isLocationSelected">
        <h4>Location</h4>
        <p><img src="../../../../../assets/icons/{{baseSiteId}}/location.svg" alt="location_pin">&nbsp;
            <span
                *ngIf="selectedLocations.length == 1">{{selectedLocations[0]?.facilityName}}...({{selectedLocations[0]?.accountNumber}})</span>
            <span *ngIf="selectedLocations.length > 1">Multiple locations ({{selectedLocations?.length}})</span>
        </p>
    </section>

    <!-- ---------------------------  -->



    <!-- <section *ngIf="!productInfo?.discontinued && productInfo?.available">
        <section *ngIf="productInfo.sapAllocation">
            <b class="prod-allocation">{{'addToCartItems.productAllocation' | cxTranslate}}</b>
            <p class="allocation-p">{{'addToCartItems.allocationDetails' | cxTranslate}}
        </section>
    </section> -->



</section>